<template>
  <label class="checkbox-container"
    >{{ title }}
    <input
      type="checkbox"
      :disabled="disabled"
      :value="value"
      class="widget_checkbox"
      @change="onChange"
      @blur="onBlur"
      @focus="onFocus"
      @keyup="onKeyup"
      @keydown="onKeydown"
      @click="onClick"
    />
    <span class="checkmark"></span>
  </label>
</template>

<script>
export default {
  name: "widget_checkbox",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {
    onChange(e) {
      let vm = this;
      vm.$emit("change", e);
    },
    onBlur(e) {
      let vm = this;
      vm.$emit("blur", e);
    },
    onFocus(e) {
      let vm = this;
      vm.$emit("focus", e);
    },
    onKeyup(e) {
      let vm = this;
      vm.$emit("input", e.target.value);
    },
    onKeydown(e) {
      let vm = this;
      vm.$emit("input", e.target.value);
    },
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/scss/constant_valiable.scss";
/* The checkbox-container */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 28px;
  padding-top: 2px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  background-color: #ddd;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
  background-color: #0065e1;
  border: none;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 7px;
  top: 3px;
  width: 3px;
  height: 7px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
